module.exports = __webpack_public_path__ + "static/media/receptie.20e3d3c8.mp3";